import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useResumes } from './useResumes'

/**
 * Resume requirement gating: hasResume, loading, and requireResume for redirect.
 * Use when gating actions that need at least one resume.
 *
 * - While isLoading, do not show disabled state (no flash of disabled UI).
 * - requireResume(redirectTo?) returns true if allowed, false and navigates if not.
 */
export const useResumeRequirement = () => {
  const { resumes, isLoading } = useResumes()
  const navigate = useNavigate()
  const hasResume = (resumes?.length ?? 0) > 0

  const requireResume = useCallback(
    (redirectTo = '/resumes') => {
      if (isLoading) return true
      if (!hasResume) {
        navigate(redirectTo)
        return false
      }
      return true
    },
    [hasResume, isLoading, navigate],
  )

  return { hasResume, isLoading, requireResume }
}

export type UseResumeRequirementReturn = ReturnType<typeof useResumeRequirement>
